<template>
  <v-row>
    <v-col 
      lg="6"
      md="8" 
      sm="8" 
      xs="12">
      <app-widget 
        :loading="loading"
        :title="edit ? $t('common.form.edit') : $t('common.form.create')">
        
        <device-form 
          :loading="loading"
          slot="widget-content"
          :edit="edit"
          :device="device"
          @onFormSubmit="formSubmitted" />
      </app-widget>
    </v-col>
  </v-row>
</template>

<script>
import DeviceForm from '@/components/devices/DeviceForm';
import AppWidget from '@/components/widgets/AppWidget';

export default {
  name: 'SingleDevice',
  props: {
    device: Object,
    onFormSubmitted: Function,
    loading: Boolean
  },
  computed: {
    edit() {
      return this.$route.meta.edit;
    }
  },
  methods: {
    formSubmitted(device) {
      this.onFormSubmitted(device);
    }
  },
  components: {
    DeviceForm,
    AppWidget
  }
}
</script>